import { type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { QueryErrorScreen } from '@/shared/components/ui'
import { routes } from '@/shared/constants'
import { useAuth } from '../hooks/useAuth'
import { AuthSplash } from './AuthSplash'

/**
 * Guard del área autenticada.
 *
 * Basa la sesión únicamente en la query `me` (vía Apollo). Si no hay token en
 * memoria, el errorLink intenta renovar con la cookie httpOnly de refresh; si
 * tampoco hay cookie, la query falla y redirigimos a `/login`.
 *
 * No depende de ningún flag local ni de localStorage.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading, error } = useAuth()

  if (loading) {
    return <AuthSplash message="Verificando sesión…" />
  }

  if (error) {
    return (
      <QueryErrorScreen
        error={error}
        title="No pudimos verificar tu sesión"
        onSecondary={() => window.location.assign(routes.public.login)}
        secondaryLabel="Ir al login"
      />
    )
  }

  if (!user) {
    return <Navigate to={routes.public.login} replace />
  }

  return <>{children}</>
}
